// extracted by mini-css-extract-plugin
export default {"tagManageBox":"tagManage_tagManageBox__xUP08","operateBox":"tagManage_operateBox__sTbmR","tagBox":"tagManage_tagBox__D6tjJ","sortTree":"tagManage_sortTree__UV+x2","treeTitle":"tagManage_treeTitle__C02h0","tagList":"tagManage_tagList__+UF-a"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"tagManageBox\":\"tagManage_tagManageBox__xUP08\",\"operateBox\":\"tagManage_operateBox__sTbmR\",\"tagBox\":\"tagManage_tagBox__D6tjJ\",\"sortTree\":\"tagManage_sortTree__UV+x2\",\"treeTitle\":\"tagManage_treeTitle__C02h0\",\"tagList\":\"tagManage_tagList__+UF-a\"}";
        // 1793842499728
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  